export default "__VITE_ASSET__I8A5j8s8__"